"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBaseSchema = void 0;
const getBaseSchema = (type, options = {}) => {
    return Object.assign({
        '@context': 'https://schema.org',
        ...(type && { '@type': type }),
    }, options);
};
exports.getBaseSchema = getBaseSchema;
